export const BANNERS_PREFIX = 'banners';

// Action Types
export const INITIATED = `${BANNERS_PREFIX}/INITIATED`;
export const INITIATION_ERROR = `${BANNERS_PREFIX}/INITIATION_ERROR`;

// Amount of times banners can fail before giving up.
export const MAX_ERROR_COUNT = 3;
